export const heroSplit = `background: bahaus
|
background: second
title: Brunelleschi's Dome
subtitle: Completed in 1436 without centring or scaffolding, the dome of Florence Cathedral spans 42 metres and contains over four million bricks laid in a herringbone pattern that makes each course self-supporting during construction.
`